import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { BrightsideUiModule, PillConfig } from '@brightside/brightside-ui';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'brightside-web-payroll-payday-card',
    imports: [BrightsideUiModule, TranslateModule],
    templateUrl: './payroll-payday-card.component.html',
    styleUrl: './payroll-payday-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PayrollPaydayCardComponent implements OnInit {
  data: { remainingDays: number };
  payDayPillConfig: PillConfig;

  private _translateService: TranslateService = inject(TranslateService);

  ngOnInit(): void {
    let payDayCopyLabel: string;
    if (this.data?.remainingDays > 1) {
      payDayCopyLabel = 'PAYROLL_COUNTDOWN';
    } else if (this.data?.remainingDays === 1) {
      payDayCopyLabel = 'PAYROLL_COUNTDOWN_1DAY';
    } else {
      payDayCopyLabel = 'PAYROLL_TODAY';
    }

    this.payDayPillConfig = {
      label: this._translateService.instant(payDayCopyLabel, { number: this.data?.remainingDays }),
      labelColor: 'var(--blue-70)',
      iconLeftName: 'pay-day',
      iconLeftColor: 'var(--blue-70)',
      iconLeftSize: 25,
      iconLeftPadding: true,
      backgroundColor: 'var(--blue-10)',
    };
  }
}
